import React from 'react'
import {ItemForm} from './ItemForm'
import item from "../../redux/slices/item";

export const UpdateItem = (props) => {
    // console.log("JS = "+ JSON.stringify(props))
    // console.log("JS ", props)
    const {location} = props
    const Item = location.state;
    console.log(Item)
    return (
        <div>
            <ItemForm ActionType="Update" MItem={Item}/>
        </div>
    )
}
